import { deleteRequest } from 'utils/api/apiRequest'

export const removeWishlistItem = (product_id: number) => deleteRequest(`/redemption-site/wishlist/${product_id}`)
